export default "__VITE_ASSET__1A4$5vFG__"